import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userLoading: false,
  user: {},
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    clearUserDetailsAfterLogin: (state) => {
      state.user = {};
    },
  },
});

export default loginSlice.reducer;
export const { clearUserDetailsAfterLogin } = loginSlice.actions;
